import "../assets/style/Home.css";
import batulogo from "../assets/img/BATU_logo.png";
import cgpatoper from "../assets/img/cgpatoper.png";
import cgpacalculator from "../assets/img/cgpacalculator.png";
import gradetosgpa from "../assets/img/gradetosgpa.png";
import sgpatocgpa from "../assets/img/sgpaocgpa.png";
import { Link, useNavigate,useLocation,useSearchParams } from "react-router-dom";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { useEffect, useRef, useState } from "react";
function Home() {

  const location = useLocation();
  const driverObjRef = useRef(null);


  useEffect(() => {


const driverObj = driver({
  // showProgress: true,
  allowClose: true,
// overlayColor: '#47d3ceab',
    popoverClass: 'driverjs-theme',
    showButtons: ['next', 'previous','close'],

  steps: [
    { element: '.intro-block', popover: { title: 'Quick Start Guide', description: 'Learn how to use GPA converter...', side: "right", align: 'center' } },
    { element: '#drop-menu', popover: { title: 'Dropdown Menu', description: 'Helps to navigate to pages' } },
    { element: '#card1', popover: { title: 'CGPA to %', description: 'This tool will convert your cgpa to percentage. click on <b>Calculate</b> button to continue' } },
    { element: '#card2', popover: { title: 'Grade to SGPA', description: 'This tool will convert your Grades into SGPA. click on <b>Calculate</b> button to continue' } },
    { element: '#card3', popover: { title: 'CGPA Calculator', description: 'This tool will calculate your CGPA from total Grade points. click on <b>Calculate</b> button to continue' } },
  ],

  onDestroyStarted: () => {
    if (!driverObj.hasNextStep()) {
      
      if(localStorage.isnewuser){
        localStorage.setItem('isnewuser','false');
      }
      
      driverObj.destroy();
    }
  },

  onCloseClick:() => {

if(Number(localStorage.countsclick)>=2){
    if(localStorage.isnewuser){
      localStorage.setItem('isnewuser','false');
    }
  }
    driverObj.destroy();

    localStorage.setItem('countsclick',Number(localStorage.countsclick)+1);
    console.log(Number(localStorage.countsclick));
 
  },


  
});
driverObjRef.current = driverObj;

if(!localStorage.isnewuser){
  localStorage.setItem('isnewuser','true');
}

if(!localStorage.countsclick){
  localStorage.setItem('countsclick','0');
}

if(localStorage.isnewuser=="true"){
  driverObj.drive();
}



return () => {
  if (driverObjRef.current) {
    driverObjRef.current.destroy(); 
  }
};
}, [location.pathname]);


  return (
    <div className="container-fluid p-0">
      <div className="container-fluid p-0">
        <div className="intro-block">
          <img src={batulogo} alt="University Logo" className="logo" id="logo-batu" />
          <h1>Welcome to GPA Converter!</h1>
          <p>
            Effortlessly convert your DBATU grades!<br></br> Get accurate CGPA to %, Grades to SGPA and SGPA to CGPA conversions with our user-friendly
            online tool.
          </p>
        </div>
      </div>

      <div className="container-fluid pt-5 pb-5">
        <div className="row justify-content-center gap-1 gap-lg-3 flex-column flex-lg-row flex-md-row">
            <Link to='/cgpa-to-percent' className="col anim" id='card1'>
              <div className="card">
              <img src={cgpatoper} width={"100%"}  alt="" />
                <div className="card-body">
                  {/* <h5 className="card-title">Card title</h5>
                  <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                  <Link to="/cgpa-to-percent" id="btn1" className="btn btn-sm w-100  btn-primary">Calculate</Link>
                </div>
              </div>
            </Link>
           

            <Link to='/grade-to-sgpa' className="col anim" id='card2'>
            <div className="card">
            <img src={gradetosgpa} width={"100%"}  alt="" />
              <div className="card-body">
                {/* <h5 className="card-title">Card title</h5>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                <Link to="/grade-to-sgpa" id="btn2" className="btn btn-sm w-100  btn-primary">Calculate</Link>
              </div>
            </div>
            </Link>

            <Link to='/cgpa-calculator' className="col anim" id='card3'>
            <div className="card">
            <img src={cgpacalculator} width={"100%"}  alt="" />
              <div className="card-body">
                {/* <h5 className="card-title">Card title</h5>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                <Link to="/cgpa-calculator" id="btn3" className="btn btn-sm w-100 btn-primary">Calculate</Link>
              </div>
            </div>
            </Link>

        </div>
       

      </div>

  
    </div>
  );
}



export default Home;
